// Medical aid tax credits for 2023-2024 tax year
export const MEDICAL_AID_CREDITS_2023_24 = {
  mainMember: 347,        // R347 per month for main member
  firstDependent: 347,    // R347 per month for first dependent
  additionalDependent: 234 // R234 per month for each additional dependent
};

// Annual amounts (multiply monthly by 12)
export const ANNUAL_MEDICAL_AID_CREDITS_2023_24 = {
  mainMember: MEDICAL_AID_CREDITS_2023_24.mainMember * 12,           // R4,164
  firstDependent: MEDICAL_AID_CREDITS_2023_24.firstDependent * 12,   // R4,164
  additionalDependent: MEDICAL_AID_CREDITS_2023_24.additionalDependent * 12 // R2,808
};